import { ISelectHierarchyOption, SelectHierarchy } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../../../contentConstants';
import { IValidationResult } from '../../../models';
import { ITrendGroup } from '../../../models/ITrendGroup';

export interface ITrendGroupProps {
	validationResults?: IValidationResult;
	trendGroups: ITrendGroup[];
	firstTrendGroupItem?: ITrendGroup;
	selectedTrendGroupId?: string;
	disabled?: boolean;
	onChange: (trendGroupId: string) => void;
}

export default class TrendGroup extends React.Component<ITrendGroupProps> {
	constructor(props: ITrendGroupProps) {
		super(props);
	}

	public render() {
		const { disabled, trendGroups, firstTrendGroupItem } = this.props;
		const errors = this.props.validationResults && this.props.validationResults.errors ? this.props.validationResults.errors : [];

		const items: ISelectHierarchyOption[] =
			trendGroups &&
			trendGroups.map((tg: ITrendGroup) =>
				tg.parentTrendGroupId
					? {
							id: tg.trendGroupId,
							// SelectHierarchy compares based on name so we put ID here to pass back as the selected value
							name: tg.trendGroupId,
							displayText: tg.displayText,
							parentId: tg.parentTrendGroupId,
					  }
					: {
							id: tg.trendGroupId,
							// SelectHierarchy compares based on name so we put ID here to pass back as the selected value
							name: tg.trendGroupId,
							displayText: tg.displayText,
					  },
			);

		const firstItem = firstTrendGroupItem && {
			id: firstTrendGroupItem.trendGroupId,
			name: firstTrendGroupItem.trendGroupId,
			displayText: firstTrendGroupItem.displayText,
		};

		return (
			<div>
				<SelectHierarchy
					error={errors.indexOf(ContentConstants.REPORTINGTREND_VALIDATE_TRENDGROUP) > -1}
					message={ContentConstants.PLACEHOLDER_REPORTING_ERROR_SELECT_VALUE}
					items={items}
					firstItem={firstItem}
					displayText='Trend Groups'
					selectSize='xlg'
					showSearch={true}
					placeHolderText='Search'
					onRadioChange={this.props.onChange}
					selectedValue={this.props.selectedTrendGroupId}
					disabled={disabled}
				/>
			</div>
		);
	}
}
